import { render, staticRenderFns } from "./AssistentTemplatePicker.vue?vue&type=template&id=456ca858&scoped=true&"
import script from "./AssistentTemplatePicker.vue?vue&type=script&lang=js&"
export * from "./AssistentTemplatePicker.vue?vue&type=script&lang=js&"
import style0 from "./AssistentTemplatePicker.vue?vue&type=style&index=0&id=456ca858&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456ca858",
  null
  
)

export default component.exports